import PropTypes from 'prop-types'
import styled from 'styled-components'

const sizes = {
  tiny: '18px',
  small: '24px',
  medium: '32px',
  large: '48px'
}
const StyledIconWrapper = styled.span`
  line-height: normal;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'auto')};
  width: ${({ isCentered }) => (isCentered ? '100%' : 'auto')};
  ${({ color }) => (color ? `color: ${color}` : null)};
  svg {
    height: ${({ size, height }) => height || sizes[size] || '1em'};
    width: ${({ size, width }) => width || sizes[size] || '1em'};
    pointer-events: none;
    overflow: hidden;
  }
`
/**
 * An Icon can be used to render different SVG files and capture click interactions.
 */
const Icon = ({
  color,
  width,
  height,
  onClick,
  size = 'small',
  label = 'icon',
  isCentered = false,
  dangerouslySetGlyph = '',
  glyph: Glyph = () => {},
  ...rest
}) => {
  const props = {
    color,
    width,
    height,
    size,
    onClick,
    isCentered,
    role: 'img',
    'aria-label': label,
    ...rest
  }
  const children = Glyph ? <Glyph /> : null

  if (dangerouslySetGlyph) {
    return (
      <StyledIconWrapper
        aria-hidden={true}
        dangerouslySetInnerHTML={{ __html: dangerouslySetGlyph }}
        {...props}
      />
    )
  }

  return (
    <StyledIconWrapper aria-hidden={true} {...props}>
      {children}
    </StyledIconWrapper>
  )
}

Icon.propTypes = {
  /** Set the glyph with a sanitized SVG string */
  dangerouslySetGlyph: PropTypes.string,
  /** Set the glyph as a component */
  glyph: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  /** Callback when icon is clicked */
  onClick: PropTypes.func,
  /** aria-label */
  label: PropTypes.string,
  /** Sets the color used for fill: currenColor */
  color: PropTypes.string,
  /** Determine the size of the component. One of: 'small', 'medium', 'large' */
  size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large']),
  /** Sets the height (overrides size prop) */
  height: PropTypes.string,
  /** Sets teh width (overrides size prop) */
  width: PropTypes.string,
  /** Whether the icon is centered within its parent element */
  isCentered: PropTypes.bool
}

export { Icon }
